<template>
  <a-drawer
    title="材料项管理"
    placement="right"
    :width="1200"
    :visible="innerVisible"
    @close="close"
    destroyOnClose>
    <!-- 下面内容完全沿用你之前那套 table / pagination / create-form -->
    <a-card :bordered="false">
      <!-- 搜索条 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="材料名称">
                <a-input v-model="queryParam.name" placeholder="请输入" allow-clear @keyup.enter="handleQuery" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" allow-clear>
                  <a-select-option :value="1">启用</a-select-option>
                  <a-select-option :value="0">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"> <a-icon type="search" />查询 </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"> <a-icon type="redo" />重置 </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作条 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd(materialId)" v-hasPermi="['upkeep:material-item:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['upkeep:material-item:edit']"
        >
          <a-icon type="edit" />修改
        </a-button>

        <a-button type="danger" :disabled="deletableRows.length === 0" @click="handleDelete">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          style="float: right"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <!-- 列表 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <a-switch :checked="record.status === 1" @change="handleStatusType(record.id, record.status === 1 ? 0 : 1)" />
        </span>
        <div slot="pic" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.pic"
              style="width: 50px; height: 50px"
              @error="(e) => (e.target.src = errorImage)"
            />
          </div>
        </div>
        <div slot="icon" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.icon"
              style="width: 50px; height: 50px"
              @error="(e) => (e.target.src = errorImage)"
            />
          </div>
        </div>
        <span slot="operation" slot-scope="text, record">
          <a v-hasPermi="['upkeep:material-item:remove']" v-if="record.status === 0" @click="handleDelete(record)">删除</a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 新建/编辑弹窗 -->
    <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" />
  </a-drawer>
</template>

<script>
import { fetchList, delObj, statusObj } from '@/api/maintenance/materialitems/index'
import CreateForm from '@/views/maintenance/materialitems/modules/CreateForm.vue'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'MaterialItemsDrawer',
  mixins: [tableMixin],
  components: { CreateForm },
  dicts: ['sys_enable_disable'],
  data() {
    return {
      rowSelection() {
        return {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange,
          // 关键：只有 status=0 才允许勾选
          getCheckboxProps: (record) => ({
            props: {
              disabled: record.status !== 0, // 0=禁用/可删
            },
          }),
        }
      },
      innerVisible: false, // 抽屉自己内部维护的开关
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      errorImage: require('/src/assets/images/defaultImg.png'),
      total: 0,
      materialId: '', // 材料id
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        name: '',
        status: undefined,
        materialId: '',
      },
      columns: [
        { title: '材料名称', dataIndex: 'name', align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '材料图片', dataIndex: 'pic', scopedSlots: { customRender: 'pic' }, align: 'center' },
        { title: '材料图标', dataIndex: 'icon', scopedSlots: { customRender: 'icon' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '备注', dataIndex: 'remark', ellipsis: true, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  computed: {
    deletableRows() {
      return this.selectedRows.filter((v) => v.status === 0)
    },
  },
  methods: {
    /* -------- 父级命令式调用 -------- */
    open(e) {
      this.queryParam.materialId = e
      this.materialId = e
      this.innerVisible = true
      this.getList()
    },
    close() {
      this.innerVisible = false
      this.resetQuery() // 关闭时顺便清条件
      this.onSelectChange([], []) // 清选中
    },

    /* -------- 下面全是原来的逻辑 -------- */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        name: '',
        materialId: this.materialId,
        status: undefined,
      }

      this.handleQuery()
    },
    handleStatusType(id, status) {
      statusObj({ id }).then(() => {
        this.$message.success('操作成功')
        this.getList()
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    // 删除方法
    handleDelete(row) {
      // 单行/批量统一处理：只删 status=0
      const list = row?.id
        ? [row] // 单行
        : this.deletableRows // 批量
      if (!list.length) return this.$message.warn('没有可删除的数据')

      const ids = list.map((v) => ({ id: v.id }))
      this.$confirm({
        title: `确定删除 ${list.length} 条数据？`,
        onOk: () =>
          delObj(ids).then(() => {
            this.$message.success('删除成功')
            this.onSelectChange([], []) // 清空选中
            this.getList()
          }),
      })
    },
  },
}
</script>
